import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const KebabIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="kebab" ref={ref as any} {...props}>
      <path
        d="M14.3893 20C14.3893 21.1046 13.4939 22 12.3893 22C11.2848 22 10.3893 21.1046 10.3893 20C10.3893 18.8954 11.2848 18 12.3893 18C13.4939 18 14.3893 18.8954 14.3893 20Z"
        fill="currentColor"
      />
      <path
        d="M14.3893 12C14.3893 13.1046 13.4939 14 12.3893 14C11.2848 14 10.3893 13.1046 10.3893 12C10.3893 10.8954 11.2848 10 12.3893 10C13.4939 10 14.3893 10.8954 14.3893 12Z"
        fill="currentColor"
      />
      <path
        d="M14.3893 4C14.3893 5.10457 13.4939 6 12.3893 6C11.2848 6 10.3893 5.10457 10.3893 4C10.3893 2.89543 11.2848 2 12.3893 2C13.4939 2 14.3893 2.89543 14.3893 4Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
